import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { fetchOffreLancementStatus } from "@/lib/api";

export const OffreLancementTeaser = ({ compact = false }) => {
  const [s, setS] = useState(null);
  useEffect(() => { fetchOffreLancementStatus().then(setS).catch(() => {}); }, []);
  if (!s || s.complete) return null;
  const txt = `Plus que ${s.restantes} place${s.restantes > 1 ? "s" : ""}`;
  if (compact) {
    return <span className="ml-2 inline-flex items-center rounded-full bg-amber-300 text-[#0f1a2b] text-[11px] font-black px-2 py-0.5" data-testid="offre-teaser-compact">{txt}</span>;
  }
  return (
    <section className="max-w-7xl mx-auto px-6 mt-10" data-testid="offre-teaser">
      <Link to="/hotelleries/offre-lancement" className="group flex flex-wrap items-center justify-between gap-4 rounded-3xl bg-[#0f1a2b] text-white px-6 py-5 hover:bg-[#16243a] transition-colors">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-amber-300 text-[#0f1a2b] flex items-center justify-center shrink-0"><Gift size={22} /></div>
          <div>
            <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-amber-300">Offre de lancement hoteliers</div>
            <div className="font-black text-lg leading-tight">{s.jours_gratuits} jours Pro Hotel offerts — <span className="text-amber-300" data-testid="offre-teaser-count">{txt}</span> sur {s.total}</div>
          </div>
        </div>
        <span className="inline-flex items-center gap-2 text-sm font-bold text-amber-300 group-hover:translate-x-1 transition-transform">Reserver ma place <ArrowRight size={16} /></span>
      </Link>
    </section>
  );
};
